<template>
    <div v-if="shouldShow" class="star-background">
        <img class="homebg" src="/assets/images_star/home/homebg.png" alt="" />
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { getTheme } from '@/styles/theme';

// 判断是否为星空主题
const shouldShow = computed(() => {
    return getTheme() === 'star';
});
</script>

<style scoped lang="scss">
.star-background {
    .homebg {
        width: 100%;
        height: 120vh;
        position: fixed;
        top: 0;
        left: 0;
        z-index: -1000;
        object-fit: cover;
    }
}
</style>
